import { render, staticRenderFns } from "./UserDataModal.vue?vue&type=template&id=88e44776"
import script from "./UserDataModal.vue?vue&type=script&lang=js"
export * from "./UserDataModal.vue?vue&type=script&lang=js"
import style0 from "./UserDataModal.vue?vue&type=style&index=0&id=88e44776&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports